import { ts } from '_core';

// prepareRiskFactorExposureData
export const transform = (data: ts.types.widgets.TableData) => {
  const newData = data.map((item) => {
    const newItem = {} as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      if (key != 'tab') {
        if (item[key] !== null) newItem[key] = item[key];
      }
    });
    return newItem;
  });

  return newData;
};
